import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Topbar from "../../../Component/Topbar/Topbar";
import { get, post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import toast from "react-hot-toast";
import useSearchFunction from "../../../Component/searchFunction";
const Region = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [activeRegion, setActiveRegion] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [regions, setRegions] = useState([]);

  const debounceval = useSearchFunction(searchValue);

  // const regions = ["South1", "South2", "South3", "West", "East", "North", "Central"];

  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res.roles)) {
      setRegions(res?.roles);

      // 🔹 Convert API data to Select options
      // const options = res?.roles.map((region) => ({
      //   value: region?.id,
      //   label: region?.name,
      // }));
      // setRegionOptions(options);

      // 🔹 If you also want to preselect a region (e.g. from user profile)
      // const regionId = res?.roles?.id || null; // adjust key as per API
      // if (regionId) {
      //   const selected = options.find((opt) => opt.value === regionId);
      //   if (selected) {
      //     setValue("region", selected);
      //     console.log("ddd", selected);

      //   }
      // }
    }
  };

  const statusChange = async (id) => {
    console.log("id", id);
    const payload = {
      id: id,
    };
    let res = await post(URLS.MASTERSTATUS + id, payload);
    if (res?.status == "success") {
      toast.success(res?.message);
      // setList(res?.admins);
      MasterList();
    }
  };

  const MasterList = async (search) => {
    setSearchValue(search);
    const payload = {
      // type: 1,
      region_id: activeRegion?.id,
      search: search,
      page: page,
    };
    let res = await post(URLS.LOCATIONLIST, payload);
    if (res?.status == "success") {
      let mapData = res?.region_location?.map((i) => {
        return {
          ...i,
          page: res?.pagination_meta?.current_page,
        };
      });
      setList(mapData);
      setPagination(res?.pagination_meta);
    }
  };

  useEffect(() => {
    MasterList(debounceval);
    regionList();
  }, [debounceval, activeRegion, search, page]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "page",
        Cell: ({ value, row }) => {
          return <p>{(value - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },
      {
        Header: "Location",
        accessor: "location",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Status",
        accessor: "location.status",
        Cell: ({ value, row }) => (
          <div className="d-flex ac-js mt-2">
            <button
              onClick={() => statusChange(row?.original?.location?.id)}
              className={`${
                value === 0 ? "deactive-icon1" : "active-icon1"
              } f2 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15  fs-xxl-16`}
            >
              {value === 0 ? "De-active" : "Active"}
            </button>
          </div>
        ),
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc   mt-2 gap-3">
                <button
                  onClick={() => {
                    navigate("/region-add", {
                      state: {
                        type: "view",
                        id: row?.original,
                        data: row?.original,
                      },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={view} alt="" className=" editor-btn " />
                </button>

                <button
                  onClick={() => {
                    navigate("/region-add", {
                      state: {
                        type: "edit",
                        id: row?.original,
                        data: row?.original,
                      },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={edit} alt="" className=" editor-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [],
  );
  return (
    <>
      <Topbar header={"Region"} />
      <div className="container_fluit1">
        <div className="d-flex ac-jb">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total : {pagination?.total}
          </h4>
          <button
            onClick={() => navigate("/region-add", { state: { type: "add" } })}
            className="Add_btn1 f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            ADD
          </button>
        </div>
        <div className="d-flex ac-jb gap-4">
          <div className="d-flex ac-js gap-2">
            <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
              Region :
            </h4>
            <div className="d-flex flex-wrap">
              {/* {regions.map((region) => (
                <button
                  key={region}
                  onClick={() => setActiveRegion(region)}
                  className={`region-btn f3 fs-sm-13 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 ${activeRegion === region ? "region_active" : ""
                    }`}
                >
                  {region}
                </button>
              ))} */}
              <button
                onClick={() => setActiveRegion(null)}
                className={`region-btn f3 fs-sm-13 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 ${
                  activeRegion === null ? "region_active" : ""
                }`}
              >
                All
              </button>
              {regions.map((region) => (
                <button
                  key={region.id}
                  onClick={() => setActiveRegion(region)}
                  className={`region-btn f3 fs-sm-13 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 ${
                    activeRegion?.id === region.id ? "region_active" : ""
                  }`}
                >
                  {region.name}
                </button>
              ))}
            </div>
          </div>

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              type="text"
              placeholder="Search "
              style={{ border: "none", width: "200px" }}
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list}
          show={true}
        />
      </div>
    </>
  );
};

export default Region;
